module.exports = __webpack_public_path__ + "img/icon_spacepuzzle.3cdbb5ca.png";